<template>
  <authorization permissionKey="island_identification_queue" can="read">
    <Attendances
      v-if="attendancePlace"
      queueType="identification"
      :attendancePlaceId="attendancePlace.id"
      :pollInterval=60000
    />
  </authorization>
</template>

<script>
  import Attendances from "@/components/queues/attendances.vue";

  export default {
    name: "Identification",
    components: {
      Attendances,
    },
    props: {
      attendancePlace: Object,
    },
  };
</script>

<style lang="scss" scoped></style>
